import { motion } from "framer-motion";
import { TrendingUp, Building2, Landmark } from "lucide-react";

const services = [
  {
    icon: TrendingUp,
    title: "Investment Advisory",
    description:
      "Identifying premium on and off-market property opportunities. We provide rigorous analysis, market intelligence, and strategic guidance to help investors deploy capital with conviction.",
  },
  {
    icon: Building2,
    title: "Development Management",
    description:
      "From site acquisition through planning, construction, and settlement — we manage the full development lifecycle with precision and accountability.",
  },
  {
    icon: Landmark,
    title: "Capital Structuring",
    description:
      "We assist in structuring optimal capital solutions for development projects, connecting developers and investors through carefully considered arrangements aligned to risk and return.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-36"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section label */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-sm tracking-[0.2em] uppercase mb-4"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 500,
            color: "var(--gold-dark)",
          }}
        >
          What We Do
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-3xl md:text-4xl lg:text-5xl tracking-tight mb-16 md:mb-20"
          style={{
            fontFamily: "var(--font-serif)",
            fontWeight: 400,
            color: "var(--text-primary)",
          }}
        >
          Our Capabilities
        </motion.h2>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: index * 0.15,
                ease: [0.25, 0.46, 0.45, 0.94],
              }}
              className="service-card"
              data-testid={`service-card-${index}`}
            >
              <service.icon
                size={28}
                strokeWidth={1.2}
                style={{ color: "var(--gold-dark)" }}
                className="mb-6"
              />
              <h3
                className="text-2xl md:text-[1.75rem] tracking-tight mb-4"
                style={{
                  fontFamily: "var(--font-serif)",
                  fontWeight: 600,
                  color: "var(--text-primary)",
                }}
              >
                {service.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{
                  fontFamily: "var(--font-sans)",
                  fontWeight: 300,
                  color: "rgba(26, 26, 26, 0.75)",
                  lineHeight: 1.8,
                }}
              >
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
